import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastProvider } from './contexts/ToastContext';
import { ConfirmProvider } from './contexts/ConfirmContext';
import Layout from './components/Layout';
import Monitor from './pages/Monitor';
import Analysis from './pages/Analysis';
import Diagnosis from './pages/Diagnosis';
import Device from './pages/Device';
import Alarm from './pages/Alarm';
import Profile from './pages/Profile';

function App() {
  return (
    <ToastProvider>
      <ConfirmProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/" element={<Navigate to="/monitor" replace />} />
              <Route path="/monitor" element={<Layout><Monitor /></Layout>} />
              <Route path="/analysis" element={<Layout><Analysis /></Layout>} />
              <Route path="/diagnosis" element={<Layout><Diagnosis /></Layout>} />
              <Route path="/device" element={<Layout><Device /></Layout>} />
              <Route path="/alarm" element={<Layout><Alarm /></Layout>} />
              <Route path="/profile" element={<Layout><Profile /></Layout>} />
            </Routes>
          </div>
        </Router>
      </ConfirmProvider>
    </ToastProvider>
  );
}

export default App;
